/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-13 19:28:40
 * @Description: 公告管理
 */
"use strict";
angular.module("noticeManagementRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage.noticemanagement", {
        url: "/noticemanagement",
        views: {
            "": {
                template:'<div class="view_content view_content_full noticemanagement" ui-view="main"></div>'
            },
            "main@backstage":{
                templateUrl:'./main/backstage/noticeManagement/noticeManagement_tpl.html',
                controller:'noticeManagementCtrl'
            }
        }
    });
}]);